import { createNode } from '@glueapp/graph-types';
import { createNullable } from '@glueapp/graph-types';

export const GetIfNotNull = createNode({
    id: 'Get If Not Null',
    name: 'Get If Not Null',
    description: `Takes in a nullable value and returns the value if it is not null, otherwise doesn't run`,
    aiDescription: [
        'Unwraps a nullable value. If non-null, outputs the unwrapped value and allows downstream execution.',
        'If null, downstream nodes connected to "Output" will NOT execute (execution decision = false).',
        'Input port "Input" accepts nullable<T>. Output port "Output" emits T (non-nullable).',
        'Generic type: the output type matches the inner type of the nullable input.',
    ].join('\n'),
    category: 'Object',
    color: '#a17ee2',
    integration: undefined,
    inPorts: {
        Input: createNullable({ kind: 'generic', identifier: 'T' }),
    },
    outPorts: {
        Output: { kind: 'generic', identifier: 'T' },
    },
    hasExecutionDecisions: true,
    execute: function (input) {
        if (input.inPorts.Input === null) {
            return { output: { Output: null }, executionDecisions: { Output: false } };
        } else {
            return { output: { Output: input.inPorts.Input }, executionDecisions: { Output: true } };
        }
    },
});
